module.exports = __webpack_public_path__ + "static/the_inn_between_main_logo-06ee414f8ba2cf9743f1aa1ff51b15c1.png";